import { Box, Center, Flex, FlexProps, Icon, IconProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

import MenuIcon from '~/shared/components/ds2/assets/Menu.svg?react';
import NewIcon from '~/shared/components/ds2/assets/New.svg?react';
import Menu, { MenuItemProps } from '~/shared/components/ds/Menu';
import { useMenuItems } from '~/shared/utils/useMenuItems.tsx';

interface HeaderProps extends FlexProps {
  customMenuItems?: MenuItemProps[];
  customHeader?: ReactNode;
  newButtonProps?: IconProps & { isDisabled?: boolean };
}

const iconSharedProps: IconProps = {
  boxSize: '18px',
  pos: 'relative',
  cursor: 'pointer',
  transition: '0.2s',
  fill: 'greyDark',
};
const iconDisabledProps: IconProps = {
  opacity: 0.32,
  cursor: 'not-allowed',
  fill: 'greyDark !important',
  onClick: () => {},
};

export default function Header({
  customMenuItems,
  customHeader,
  newButtonProps,
  ...rest
}: HeaderProps) {
  const menuItems = useMenuItems(customMenuItems);
  const { isDisabled, ...restNewButtonProps } = newButtonProps || {};

  return (
    <Flex h="40px" flexShrink={0} align="center" justify="space-between" {...rest}>
      {menuItems.length ? (
        <Menu
          MenuButton={
            <Center>
              <Icon {...iconSharedProps} _groupHover={{ fill: 'primaryDark' }} as={MenuIcon} />
            </Center>
          }
          items={menuItems}
          pos="relative"
          bottom="8px"
          left="4px"
        />
      ) : (
        <Box />
      )}

      {customHeader || (
        <Icon
          as={NewIcon}
          _hover={{ fill: 'primaryDark' }}
          {...iconSharedProps}
          {...restNewButtonProps}
          {...(isDisabled ? iconDisabledProps : {})}
        />
      )}
    </Flex>
  );
}
